import { Box, styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
    TermsBox: styled(Box)`
        display: flex;
        border: 1px solid #174150;
        padding: 16px;
        width: 341px;
        border-radius: 8px;
        margin-top: 16px;
        text-align: left;
        gap: 12px;
    `,

    Logo: styled("img")`
        width: 50px;
        height: 50px;
    `,
};
